import { Injectable } from '@angular/core';


export class _dxradiogroup{
  items?:any
  layout="horizontal"
}
export class _tab{
  title?:string
  icon?:string
  disabled?:boolean
  colonneDxDataGrid?:_colonne[];
  name:string;
}

export class _relatedField{
  api?:string;//  Puo Assumere i valori currentDs, currentData, apiweb
  dataField?:any[];  // [{fieldDatasource:xxxx,fieldDestination:yyyyy}
  valore?:string;  // se value il valore del campo altrimenti datafield del record corrente
  key?:string; // key di ricerca sul datasource con value espresso nel campo valore
  queryString?:string; // filtro da applicare a apiWeb  https://www.rentrincliud.it/cer/{{value}}
  executeFunc?:string;// funzione in javasript 
  ExecuteRoutine?:string;//funzione in javascript
  onError?:string;// funzione javascript per errore su chiamata apiweb
}
export class _cascateLookUp{
  api?:string;
  dataField?:string;
  filter?:string;
  text?:any;
  hint?:any;
  iconSize?:any
 
}

export class _button{
  name:string;
  icon?:string;
  text?:string;
  type?:string;
  hint?:any;
  location?:string;
  disabled?:boolean;
  focusStateEnabled?:boolean;
  eventi?:_Eventi[];
}
export class _Eventi{
  'event':any;
  'function'?:any;
  'ExecuteRoutine'?:any;
}[]
export class _CheckButton{
  api?:any;
  dataField?:string;
  filter?:string;
}
export class _itemForm{  
  dataField:string;
  itemType?:string;
  colSpan?:string;
  colCount?:string;
  editorType?:string;
  caption?:string;
  templateLabel?:any;
  icon?:string;
  
  disabled?:boolean;
  tabs?:_tab[]; 
}

export class _itemGroup{  
  colSpan?:string;
  colCount?:string;
  caption?:string;
  name?:string;
  type:string;     // group,tabs
  items?: _itemForm[];
}
export class _dxolookup{
  api?:string;
  dataSurce?:any;
  displayExpr?:string;
  valueExpr?:string;
  filter?:string;
  cascating?:_cascateLookUp;
}
export class _colonne{
  //button?:_button
  currentValue?:any;
  colSpan?:string;
  template?:string;
  dataField?:string;
  defaultValue?:any;
  itemType?:string;
  editorType?:string;
  dataType?:string;
  caption?:string;  
  colVisible?:boolean;  
  optionalButton?:_button[];
  isForm?:boolean=true;
  isDataGrid?:boolean=true
  icon?:string;
  type?:string;           // valori ammessi: campo
  relatedField?:_relatedField[]; // definisce un o i campi che verranno cambiati quando cambia il valore
  dxolookup?:_dxolookup;  // Definisce lookupdel campo
  dxradiogroup?:_dxradiogroup; // opzioni per radioBox
  editorOptions?:any;
  onFlyEditorOptions?:any[];
  eventi?:_Eventi[];
  tabs?:_tab[];
}



export class _dataGridConfig {
  dataSource?:any;
  Api?:string;
  QueryString?:string;
  key?:string;   
  selectedRowKeys?:any[];
  form?: {   
    headerHtml?:string; 
    itemGroup?:_itemGroup[];
    colCount?:string;
    colSpan?:string;
  };
  colonneDxDataGrid?:_colonne[];
}

@Injectable({
  providedIn: 'root'
})
export class NicaGridInterfaceService {

  constructor() { }
}
